import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { EventToolbox } from 'client/utils/event-toolbox';
import { TrackingConstant } from 'client/tracking/constant';
import { LeaseDealsCta } from 'site-modules/lease-deals/components/lease-deals-cta/lease-deals-cta';
import { useStickyIntersection } from 'site-modules/lease-deals/hooks/use-sticky-intersection/use-sticky-intersection';
import { EDM_LEASE_DEALS_STICKY_CTA_CREATIVE_ID } from 'site-modules/lease-deals/constants/lease-deals-constants';

export function StickyLeaseDealsCta({
  buttonToObserveRef,
  containerRef,
  styleId,
  make,
  model,
  year,
  trim = undefined,
  payment,
  term,
  dueAtSigning,
  endDate,
  disclaimer = undefined,
  webUrls = undefined,
  photo = undefined,
  errorImage = undefined,
  showCta = false,
  offerExpiryText = null,
}) {
  const isSticky = useStickyIntersection(buttonToObserveRef, containerRef);

  useEffect(() => {
    if (isSticky) {
      EventToolbox.fireTrackAction({
        event_type: TrackingConstant.EVENT_TYPE_WIDGET_VIEW,
        event_data: {
          action_cause: TrackingConstant.ACTION_CAUSE_SCROLL,
          action_name: TrackingConstant.ACTION_WIDGET_VIEW,
          creative_id: EDM_LEASE_DEALS_STICKY_CTA_CREATIVE_ID,
        },
      });
    }
  }, [isSticky]);

  return isSticky ? (
    <div className="lease-deals-sticky-cta bottom-0 bg-white py-0_75 px-1_5 d-flex flex-column align-items-center">
      <LeaseDealsCta
        styleId={styleId}
        make={make}
        model={model}
        year={year}
        trim={trim}
        payment={payment}
        term={term}
        dueAtSigning={dueAtSigning}
        endDate={endDate}
        disclaimer={disclaimer}
        webUrls={webUrls}
        photo={photo}
        errorImage={errorImage}
        showCta={showCta}
        buttonProps={{
          className:
            'sticky-cta-button text-transform-none text-white btn fw-medium size-16 rounded-pill py-0_5 px-1_5 w-100',
          color: 'blue-50',
          'data-tracking-parent': EDM_LEASE_DEALS_STICKY_CTA_CREATIVE_ID,
        }}
        formName="oem_lease_deal_detail"
      />
      {showCta && offerExpiryText && (
        <p className="mb-0 mt-0_5 size-16 text-cool-gray-30 text-center">{offerExpiryText}</p>
      )}
    </div>
  ) : null;
}

StickyLeaseDealsCta.propTypes = {
  buttonToObserveRef: PropTypes.shape({ current: PropTypes.object }).isRequired,
  containerRef: PropTypes.shape({ current: PropTypes.object }).isRequired,
  styleId: PropTypes.number.isRequired,
  make: PropTypes.string.isRequired,
  model: PropTypes.string.isRequired,
  year: PropTypes.number.isRequired,
  payment: PropTypes.number.isRequired,
  term: PropTypes.number.isRequired,
  dueAtSigning: PropTypes.number.isRequired,
  endDate: PropTypes.string.isRequired,
  trim: PropTypes.string,
  disclaimer: PropTypes.string,
  webUrls: PropTypes.string,
  photo: PropTypes.shape({}),
  errorImage: PropTypes.string,
  showCta: PropTypes.bool,
  offerExpiryText: PropTypes.string,
};
